import React, { useState } from "react";
import { message, Button, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { getStorage, ref, uploadBytes } from "firebase/storage";
import { getAuth } from "firebase/auth";
import Spinner from "../spinner/Spinner";

const UploadNccFileSetting = ({ onfileUrl }) => {
    const [messageApi, contextHolder] = message.useMessage();
    const storage = getStorage();
    const auth = getAuth();
    const [loading, setLoading] = useState(false);
    const [isUploaded, setIsUploaded] = useState(false);

    function unixTimestamp(date = Date.now()) {
        return Math.floor(date / 1000);
    }

    const UploadCertificate = async (file) => {
        setLoading(true);
        const timestamp = unixTimestamp();
        const fileType = file.type.split("/")[1];
        const imageUrl = `ncc/${auth.currentUser.uid}/${timestamp}.${fileType}`;

        const metadata = {
            contentType: file.type,
        };

        try {
            const storageRef = ref(storage, imageUrl);
            await uploadBytes(storageRef, file, metadata);
            messageApi.success("Your file has been uploaded successfully");
            setIsUploaded(true);
            onfileUrl(imageUrl);
        } catch (error) {
            messageApi.error(error.message || "Upload failed");
        } finally {
            setLoading(false);
        }
    };

    const props = {
        showUploadList: false,
        maxCount: 1,
        accept: ".pdf",
        customRequest: async ({ file, onSuccess }) => {
            await UploadCertificate(file);
            onSuccess("ok");
        },
    };

    return (
        <>
            {contextHolder}
            {loading && <Spinner />}
            <Upload {...props}>
                <Button
                    className={
                        isUploaded
                            ? "ncc-upload-certificate-button ncc-setting-file-uploaded"
                            : "ncc-upload-certificate-button"
                    }
                    icon={<UploadOutlined />}
                >
                    Upload Certificate File
                </Button>
            </Upload>
        </>
    );
};

export default UploadNccFileSetting;
